import { Nullable } from '@dxb-web-ui-framework/common/types';
import { AxiosError } from 'axios';
import { APIGatewayResponse } from '@dxb-web-ui-framework/common/domain/RestfulDataTransfer/DataService/types';
import { ChangeEvent } from 'react';
import { Device, DeviceData } from '../../domain/Device/entities';

export type DeviceManagementState = {
  devicesData: Nullable<DeviceData>;
  selectedDevice: Nullable<Device & { timestamp: string }>;
  setSelectedDevice: (device: Nullable<Device>) => void;
  onResetSelectedDevice: () => void;
  getDevicesData: () => void;
  loadingState: {
    isLoadingDevicesData: boolean;
  };
  errorState: {
    devicesDataError?: AxiosError<
      APIGatewayResponse<unknown>,
      { code: string; type: string; param: string; message: string }
    >;
  };
  currentPage: number;
  paginationSettings: {
    pageSize: number;
    pageOffset: number;
  };
  paginationResult: {
    totalResults: number;
    totalPages: number;
  };
  onPageChange: (event: ChangeEvent<unknown>, page: number) => void;
};

export interface DeviceManagementProviderProps {
  pageSize?: number;
}

export enum DeviceManagementContextActionTypes {
  SetSelectedDevice = '@@Device/SET_SELECTED_DEVICE',
  ResetSelectedDevice = '@@Device/RESET_SELECTED_DEVICE',
  SetCurrentPage = '@@Device/SET_CURRENT_PAGE',
  SetPaginationSettings = '@@Device/SET_PAGINATION_SETTINGS',
  SetPaginationResult = '@@Device/SET_PAGINATION_RESULT',
}
